import { Text, TextColor, TextSize, TextWeight } from '@vizit/atoms';
import { InfoCircleIcon } from '@vizit/icons';

export interface UploadScoringNoticeProps {
  /**
   * The product categories the new assets are scored against, in the order to list them
   */
  categoryNames: string[];
}

/** "A", "A and B", "A, B and C". */
function formatList(items: string[]) {
  if (items.length <= 1) {
    return items[0] ?? '';
  }
  return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
}

/**
 * The note in an upload dialog when the new assets will be scored right away: scoring takes a while, against which
 * categories, and that the assets show dimmed until then.
 */
export function UploadScoringNotice({ categoryNames }: UploadScoringNoticeProps) {
  return (
    <div className="flex flex-col gap-4 border border-blue-200 bg-blue-50 p-6">
      <div className="flex items-center gap-3 text-blue-700">
        <InfoCircleIcon size={16} aria-hidden />
        <Text size={TextSize.Sm} weight={TextWeight.Semibold} className="text-inherit">
          Scoring takes a while
        </Text>
      </div>
      <Text size={TextSize.Sm} color={TextColor.Secondary} showEllipsis={false}>
        New assets are scored against {formatList(categoryNames)}. They show dimmed until their scores are ready.
      </Text>
    </div>
  );
}
